import React, { Fragment, useMemo } from 'react';
import * as PropTypes from 'prop-types';
import isObject from 'lodash/isObject';

import BackButton from '../../../common/BackButton';
import { enhance } from './enhance';

function AppointmentHeader({
  globalPending,
  intl: { formatMessage },
  title,
  subtitle,
  handleBack,
  children,
  titleClassName,
  type,
  typeName,
}) {
  const hasTitle = Boolean(title) || Boolean(subtitle) || Boolean(children);

  const titleText = useMemo(() => {
    if (!title) return '';

    if (isObject(title)) return title.text;
    if (!isObject(title))
      return type && typeName
        ? formatMessage({ id: title }, { [type]: typeName })
        : formatMessage({ id: title });
  }, [title, type, typeName]);

  const subTitleText = useMemo(() => {
    if (!subtitle) return '';

    return isObject(subtitle)
      ? formatMessage({ id: subtitle.id }, { ...subtitle.state })
      : formatMessage({ id: subtitle });
  }, [subtitle]);

  return (
    <Fragment>
      <div styleName="header">
        <BackButton
          styleName="backBtn"
          disabled={globalPending}
          onBack={handleBack}
          minWidth={0}
        />
      </div>
      {hasTitle && (
        <div styleName="titleWrap" className={titleClassName}>
          <div>
            <h2 styleName="title">{titleText}</h2>
            {subTitleText && <h3 styleName="subTitle">{subTitleText}</h3>}
          </div>
          {children && <div>{children}</div>}
        </div>
      )}
    </Fragment>
  );
}

AppointmentHeader.propTypes = {
  children: PropTypes.node,
  globalPending: PropTypes.bool,
  intl: PropTypes.object,
  titleClassName: PropTypes.string,
  subtitle: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  title: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  handleBack: PropTypes.func.isRequired,
  type: PropTypes.string,
  typeName: PropTypes.string,
};

export default enhance(AppointmentHeader);



// WEBPACK FOOTER //
// ./src/components/AppointmentForm/Components/AppointmentHeader/index.jsx